import { useEffect, useState } from "react";
import {
  getDocRequest,
  handleAcceptDoc,
  handleRejectDoc,
  refuseRequest,
} from "../../../../services/Api/requestService";
import Right from "../../../../assets/icons/chevron-right.svg";
import "../../../../css/requestDetail.css";
import PartnerDocumentTable from "./RequestDocumentTable";
import RequestDetails from "./RequestDetails";
import { DropZoneDocument } from "../Utils/DropZoneDocument";
import { usePartnerRequestDetailsStore } from "../../../../stores/Cac/Partner/partnerRequestDetails";
import { useClickOutside } from "../../../../hooks/useClickOutside";
import { usePartnerRequestsStore2 } from "../../../../stores/Cac/Partner/partnerRequests";
import {
  unwatchDocRequest,
  watchDocRequest,
} from "../../../../services/Api/userService";
import { useNotifsStore } from "../../../../stores/Utils/notifs";
import { downloadFiles } from "../../../../services/Api/documentService";
import {
  showToastError,
  showToastSuccess,
} from "../../../../services/Toasts/toasts";
import RequestChat from "./RequestChat";
import ModalDeleteRequest from "./ModalDeleteRequest";
import ModalDeleteDoc from "../Utils/ModalDeleteDoc";

const ModalDocRequestDetails = ({ openModal, closeModal }: any) => {
  // Store
  const {
    requestId,
    openDetails,
    setOpenDetails,
    updateRequest,
    setUpdateRequest,
    missionData,
  } = usePartnerRequestsStore2();
  const { notifs } = useNotifsStore();
  const {
    request,
    setRequest,
    setComment,
    openDocuments,
    setOpenDocuments,
    openCommentary,
    setOpenCommentary,
    loading,
    setLoading,
    activeNotification,
    setRequestRefused,
    setActiveNotification,
    setLimitDate,
    setMessage,
    setMessages,
  } = usePartnerRequestDetailsStore();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openDeleteDocModal, setOpenDeleteDocModal] = useState(false);
  const [docToDelete, setDocToDelete] = useState<{ idRequest: number; idDoc: number } | null>(null);

  // Hooks
  useClickOutside([
    {
      elementId: "modal-doc-request-details",
      callback: () => setOpenDetails(false),
    },
  ]);

  // Fonction pour ouvrir la modal de suppression de document
  const handleOpenDeleteDocModal = (idRequest: number, idDoc: number) => {
    setDocToDelete({ idRequest, idDoc });
    setOpenDeleteDocModal(true);
  };

  useEffect(() => {
    setOpenCommentary(false);
    if (openDetails === true) {
      getDocRequest(requestId)
        .then((data) => {
          setRequest(data[0]);
          setLimitDate(data[0].dueDate);
          setActiveNotification(data[0]?.watching);
        })
        .catch(() => showToastError("Une erreur est survenue lors de la récupération de la requête"));
    }
  }, [requestId, updateRequest, notifs]);

  const handleClick = async () => {
    setLoading(true);
    try {
      await downloadFiles(requestId);
      setUpdateRequest(!updateRequest);
      showToastSuccess("Les documents ont bien été téléchargés");
    } catch (error) {
      showToastError("Une erreur s'est produite");
    } finally {
      setLoading(false);
    }
  };

  const handleAcceptDocButton = async (requestId: number) => {
    await handleAcceptDoc(requestId);
    setUpdateRequest(!updateRequest);
  };

  // Refuser la requête
  const handleRejectDocButton = async (requestId: number) => {
    await handleRejectDoc(requestId);
    setRequestRefused(true);
    setUpdateRequest(!updateRequest);
  };

  // Refuser la requête
  const handleRefuseRequest = (requestId: number) => {
    refuseRequest(requestId)
      .then(() => {
        setRequestRefused(true);
        setOpenDocuments("Chat");
        setUpdateRequest(!updateRequest);
        showToastSuccess("La requête a bien été refusée");
      })
      .catch(() => {
        showToastError("Une erreur est survenue lors du refus de la requête");
      });
  };

  // Suivre la notification de la requête par mail
  const handleWatchNotification = () => {
    try {
      if (activeNotification === false || activeNotification === null) {
        watchDocRequest(requestId)
          .then(() => setActiveNotification(!activeNotification))
          .catch(() => showToastError("Une erreur s'est produite"));
        } else {
        unwatchDocRequest(requestId)
          .then(() => setActiveNotification(!activeNotification))
          .catch(() => showToastError("Une erreur s'est produite"));
        }
    } catch (error) {
      showToastError("Une erreur est survenue.");
    }
  };

  useEffect(() => {
    if (openDetails === false) {
      setRequest(null);
      setComment("");
      setLimitDate("");
      setActiveNotification(false);
      setRequestRefused(false);
      setMessage("");
      setMessages([]);
      setActiveNotification(false);
    }
  }, [openDetails]);

  return (
    <div
      className={`fixed right-0 top-0 z-50 flex h-dvh w-full transform flex-col overflow-hidden bg-dark-lavender2 font-BarlowCondensed shadow-2xl transition-all duration-300 ease-in-out sm:max-w-xl lg:w-5/12 lg:max-w-none xl:w-4/12 2xl:w-3/12 ${
        openDetails ? "translate-x-0" : "translate-x-full"
      }`}
      id="modal-doc-request-details"
    >
      {openDeleteModal && <ModalDeleteRequest setOpenDeleteModal={setOpenDeleteModal} />}
      {openDeleteDocModal && docToDelete && (
        <ModalDeleteDoc
          idRequest={docToDelete.idRequest}
          idDoc={docToDelete.idDoc}
          closeModal={() => setOpenDeleteDocModal(false)}
        />
      )}
      <div className="mx-auto flex w-11/12 flex-shrink-0 flex-col">
        <button
          type="button"
          className="h-10 w-10 flex-shrink-0 cursor-pointer lg:w-20 3xl:h-20"
          onClick={() => setOpenDetails(false)}
        >
          <img src={Right} alt="chevron right" />
        </button>
        <div className="mb-3 flex w-full flex-wrap items-center justify-between gap-2 sm:mb-4">
          <p className="font-K2D text-xl text-white sm:text-2xl">
            Requête : {request?.fakeId}{" "}
          </p>
          <button
            type="button"
            disabled={missionData?.closed === 1}
            onClick={handleWatchNotification}
            className={`min-h-10 cursor-pointer rounded-lg bg-gradient-to-r from-yellow-400 to-orange-400 px-3 py-2 text-sm font-medium text-gray-800 shadow-lg transition-all duration-200 hover:from-yellow-300 hover:to-orange-300 hover:shadow-xl disabled:cursor-not-allowed disabled:opacity-50 sm:px-4 ${
              activeNotification ? "opacity-80 hover:opacity-100" : ""
            }`}
          >
            {activeNotification ? "Suivie" : "Suivre par mail"}
          </button>
        </div>

        {/* Status and Actions */}
        <div className="mb-4 flex w-full flex-col gap-3 sm:mb-6 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex w-full flex-wrap items-center gap-2 sm:w-auto sm:space-x-3">
            <div className="flex items-center bg-white/10 backdrop-blur-sm rounded-lg px-3 py-2">
              <p className="text-white text-sm font-medium mr-3">
                {request?.State?.state}
              </p>
              <div
                className={`w-3 h-3 rounded-full shadow-inner
                          ${
                            request?.State.state === "En Attente"
                              ? `bg-yellow-400 shadow-yellow-400/50`
                              : null
                          }
                          ${
                            request?.State.state === "Délivrée"
                              ? `bg-blue-400 shadow-blue-400/50`
                              : null
                          }
                          ${
                            request?.State.state === "Accepté"
                              ? `bg-green-400 shadow-green-400/50`
                              : null
                          }
                          ${
                            request?.State.state === "En retard"
                              ? `bg-red-500 shadow-red-400/50`
                              : null
                          }
                          `}
              ></div>
            </div>
          </div>
          
          {/* Action Buttons */}
          <div className="flex items-center space-x-3">
            {(request?.State?.state !== "Accepté" &&
              (request?.isPeriodClosed === null ||
              request?.isPeriodClosed === false)) ? (
              <>
                {request?.State.state === "Délivrée" && (
                  <button
                    type="button"
                    disabled={missionData?.closed === 1}
                    className="min-h-10 flex-1 cursor-pointer rounded-lg bg-gradient-to-r from-red-500 to-red-600 px-4 py-2 font-medium text-white shadow-lg transition-all duration-200 hover:from-red-600 hover:to-red-700 hover:shadow-xl disabled:cursor-not-allowed disabled:opacity-50 sm:w-24 sm:flex-none"
                    onClick={() => {
                      handleRefuseRequest(requestId);
                    }}
                  >
                    Refuser
                  </button>
                )}
                <button
                  type="button"
                  disabled={missionData?.closed === 1}
                  className="min-h-10 flex-1 cursor-pointer rounded-lg bg-gradient-to-r from-green-500 to-green-600 px-4 py-2 font-medium text-white shadow-lg transition-all duration-200 hover:from-green-600 hover:to-green-700 hover:shadow-xl disabled:cursor-not-allowed disabled:opacity-50 sm:w-24 sm:flex-none"
                  onClick={() => handleAcceptDocButton(requestId)}
                >
                  Accepter
                </button>
              </>
            ) : (request?.State?.state === "Accepté" &&
                (request?.isPeriodClosed === null ||
                request?.isPeriodClosed === false))? (
                <button
                  type="button"
                  disabled={missionData?.closed === 1}
                  className="min-h-10 w-full cursor-pointer rounded-lg bg-gradient-to-r from-yellow-500 to-orange-500 px-4 py-2 font-medium text-white shadow-lg transition-all duration-200 hover:from-yellow-600 hover:to-orange-600 hover:shadow-xl disabled:cursor-not-allowed disabled:opacity-50 sm:w-auto sm:px-6"
                  onClick={() => handleRejectDocButton(requestId)}
                >
                  Réouvrir la requête
                </button>
            ) : null}
          </div>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className="mx-auto mb-3 w-11/12 flex-shrink-0 sm:mb-5">
        <div className="flex w-full flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex w-full items-center space-x-1 overflow-x-auto rounded-xl bg-white/10 p-1 backdrop-blur-sm sm:w-auto">
            <button 
              type="button" 
              onClick={() => setOpenDocuments("Documents")}
              className={`flex-1 cursor-pointer whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium transition-all duration-200 sm:flex-none sm:px-4 sm:text-base ${
                openDocuments === "Documents" 
                  ? `bg-white text-gray-800 shadow-lg` 
                  : `text-white hover:bg-white/20`
              }`}
            >
              Documents
            </button>
            <button 
              type="button" 
              onClick={() => setOpenDocuments("Details")}
              className={`flex-1 cursor-pointer whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium transition-all duration-200 sm:flex-none sm:px-4 sm:text-base ${
                openDocuments === "Details" 
                  ? `bg-white text-gray-800 shadow-lg` 
                  : `text-white hover:bg-white/20`
              }`}
            >
              Détails
            </button>
            <button
              type="button"
              onClick={() => {
                setOpenDocuments("Chat");
                setUpdateRequest(!updateRequest);
              }}
              className={`relative flex-1 cursor-pointer whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium transition-all duration-200 sm:flex-none sm:px-4 sm:text-base ${
                openDocuments === "Chat" 
                  ? `bg-white text-gray-800 shadow-lg` 
                  : `text-white hover:bg-white/20`
              }`}
            >
              {request?.chatRead === false && (
                <div className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full animate-pulse shadow-lg"></div>
              )}
              Chat
            </button>
          </div>
          {openDocuments === "Documents" && (
            <div className="flex w-full items-center justify-end sm:w-auto">
              <button
                className={`min-h-10 w-full cursor-pointer rounded-lg px-4 py-2 text-sm font-medium transition-all duration-200 sm:w-auto ${
                  !loading
                    ? "bg-white/10 hover:bg-white/20 text-white backdrop-blur-sm hover:scale-105"
                    : "bg-blue-500 text-white cursor-not-allowed"
                }`}
                onClick={handleClick}
              >
                {!loading ? (
                  <span className="flex w-auto items-center justify-center space-x-2">
                    <svg className="h-5 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    <span>Télécharger tous</span>
                  </span>
                ) : (
                  <span className="flex items-center justify-center space-x-2 sm:w-52">
                    <svg
                      aria-hidden="true"
                      role="status"
                      className="inline w-4 h-4 animate-spin"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="#1C64F2"
                      />
                    </svg>
                    <span>Téléchargement...</span>
                  </span>
                )}
              </button>
            </div>
          )}

          {/* Action Icons */}
          <div className="flex items-center space-x-1">
            {openDocuments === "Details" && (
              <>
                <button
                  type="button"
                  className="p-2 bg-white/10 hover:bg-white/20 rounded-lg transition-all duration-200 hover:scale-110 backdrop-blur-sm"
                  title="Modifier"
                  onClick={() => setOpenCommentary(!openCommentary)}
                  disabled={missionData?.closed === 1}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                  </svg>
                </button>
                <button
                  type="button"
                  className="p-2 bg-white/10 hover:bg-white/20 rounded-lg transition-all duration-200 hover:scale-110 backdrop-blur-sm"
                  title="Supprimer"
                  onClick={() => setOpenDeleteModal(true)}
                  disabled={missionData?.closed === 1}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    <line x1="10" y1="11" x2="10" y2="17"></line>
                    <line x1="14" y1="11" x2="14" y2="17"></line>
                  </svg>
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Separator */}
      <div className="mx-auto mb-3 w-11/12 flex-shrink-0 sm:mb-5">
        <div className="h-px bg-gradient-to-r from-transparent via-white/30 to-transparent"></div>
      </div>

      {/* Content Section */}
      <div className="mx-auto min-h-0 w-11/12 flex-1 overflow-hidden sm:w-10/12">
        {openDocuments === "Documents" && (
          <div className="h-full flex flex-col">

            {/* Drop Zone */}
            {request?.State?.state !== "Accepté" && (
              <div className="mb-1">
                <DropZoneDocument requestId={requestId} />
              </div>
            )}

            {/* Document Table */}
            <div className="flex-1 overflow-hidden w-full mb-2">
              <PartnerDocumentTable 
                openModal={openModal} 
                closeModal={closeModal} 
                onDeleteDoc={handleOpenDeleteDocModal}
              />
            </div>
          </div>
        )}
        
        {openDocuments === "Details" && (
          <div className="h-full overflow-hidden mb-2">
            <RequestDetails />
          </div>
        )}
        
        {openDocuments === "Chat" && (
          <div className="h-full overflow-hidden mb-2">
            <RequestChat />
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalDocRequestDetails;